import { DialogActions, DialogContent } from '@mui/material';
import Dialog, { dialogClasses } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { DsButton } from '../buttons/DsButton';
import { DsIcon } from '../icons/DsIcon';
import { DsTypography } from '../typography/DsTypography';
import { DsModalProps } from './types';

export const DsModal = ({
  header,
  onClose,
  content,
  footer,
  size,
  fullHeight,
  maxHeight,
  headerTypographyVariant = 'h3',
  showCloseButton = true,
  limitedClose,
  contentSx,
  ...props
}: DsModalProps) => {
  const fullHeightStyle = fullHeight && { height: '90%' };

  return (
    <Dialog
      sx={{
        [`& .${dialogClasses.paper}`]: {
          maxHeight: maxHeight,
          ...fullHeightStyle,
        },
        ...props.sx,
      }}
      maxWidth={size}
      fullWidth
      {...(!limitedClose && { onClose })}
      {...props}
    >
      {props.children || (
        <>
          {(header || showCloseButton) && (
            <DialogTitle
              sx={{ p: 4, pb: header ? 4 : 0, flexDirection: header ? 'row' : 'row-reverse' }}
              className="flex justify-between items-center"
            >
              {header && typeof header === 'string' ? (
                <DsTypography variant={headerTypographyVariant} component="span">
                  {header}
                </DsTypography>
              ) : (
                header
              )}
              {onClose && showCloseButton && (
                <DsButton size="xSmall" sx={{ ...(!header && { p: 1 }) }} aria-label="close" onClick={onClose} justIcon>
                  <DsIcon size="lg" icon="CLOSE" color="iceGray.700" />
                </DsButton>
              )}
            </DialogTitle>
          )}

          {content && (
            <DialogContent
              dividers
              className="p-4 py-5"
              sx={{ ...(!header && { borderTop: 'none' }), ...(!footer && { borderBottom: 'none' }), ...contentSx }}
            >
              {content}
            </DialogContent>
          )}

          {footer && <DialogActions className="p-4 !pt-4">{footer}</DialogActions>}
        </>
      )}
    </Dialog>
  );
};
